module.exports = __webpack_public_path__ + "media/images/video-placeholder-39d84cb41d82fbb3669e0063a0ce1985.png";